@if (!selfServiceData) {
  <div class="container py-4">
    <section class="img-container text-center img-fluid py-4">
      <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="logo"
        class="logo-width-50-inline">
      <div class="centered py-4">
        <h1>{{ 'FLYGETS.SELFSERVICE.TITLE' | transloco }}</h1>
        <p class="lead">{{ 'FLYGETS.SELFSERVICE.BODY1' | transloco }}</p>
        <p class="lead">{{ 'FLYGETS.SELFSERVICE.BODY2' | transloco }}</p>
      </div>
      <mat-divider></mat-divider>
    </section>
    <form [formGroup]="selfServiceCheckForm">
      <app-text-input [formControl]='selfServiceCheckForm.controls["ordernumber"]'
        [label]="'FORM.ORDER_NUMBER' | transloco" [placeholder]="'FORM.ORDER_NUMBER' | transloco"
        [icon]="'account_box'">
      </app-text-input>
      <app-text-input [formControl]='selfServiceCheckForm.controls["lastname"]' [label]="'FORM.LAST_NAME' | transloco"
        [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'">
      </app-text-input>
      <button mat-raised-button type="button" class="my-2 width-100" (click)="loadDetails()"
        [disabled]="selfServiceCheckForm.status === 'INVALID' || isLoading"
        [ngClass]="{'success-button': selfServiceCheckForm.status === 'VALID'}">
        @if (isLoading) {
          <mat-icon>
            <mat-spinner color="accent" diameter="20">
            </mat-spinner>
          </mat-icon>
          }{{ 'FORM.CONTINUE' | transloco | uppercase}}
        </button>
        <button mat-raised-button color="warn" type="button" (click)="resetSelfServiceCheckForm()">{{ 'FORM.CLEAR' |
        transloco | uppercase}}</button>
      </form>
    </div>
  }

  @if (selfServiceData && selfServiceData.result=='DetailsRetrieved') {
    <div class="container py-4">
      <section class="img-container text-center img-fluid py-4">
        <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="logo"
          class="logo-width-50-inline">
        <div class="centered py-4">
          <h1>{{ 'FLYGETS.SELFSERVICE.TITLE' | transloco }}</h1>
          <p class="lead">{{ 'FLYGETS.SELFSERVICE.BODY_RESULT1' | transloco }}</p>
        </div>
        <mat-divider></mat-divider>
      </section>
      <form [formGroup]="selfServiceForm">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.EMAIL' | transloco }}</mat-label>
          <input matInput type="email" [formControl]='selfServiceForm.controls["email"]'
            [placeholder]="'PLACEHOLDER.EMAIL' | transloco">
          <mat-icon matSuffix>email</mat-icon>
          @if (selfServiceForm.get('email').errors?.required) {
            <mat-error>{{ 'PLACEHOLDER.EMAIL' | transloco }}
            </mat-error>
          }
          @if (selfServiceForm.get('email').errors?.email) {
            <mat-error>{{ 'ERROR.EMAIL' | transloco }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.PHONENUMBER' | transloco }}</mat-label>
          <input matInput type="text" [formControl]='selfServiceForm.controls["cellular"]'
            [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco">
          <mat-icon matSuffix>smartphone</mat-icon>
          @if (selfServiceForm.get('cellular').errors?.required) {
            <mat-error>{{ 'PLACEHOLDER.PHONENUMBER' | transloco
              }}
            </mat-error>
          }
          @if (selfServiceForm.get('cellular').errors?.pattern || selfServiceForm.get('cellular').errors?.minlength) {
            <mat-error
              >{{
            'ERROR.PHONENUMBER' | transloco }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.CARID' | transloco }}</mat-label>
          <input matInput type="text" [formControl]='selfServiceForm.controls["carRegNumber"]'
            [placeholder]="'PLACEHOLDER.CARID' | transloco">
          <mat-icon matSuffix>directions_car</mat-icon>
          @if (selfServiceForm.get('carRegNumber').errors?.required) {
            <mat-error>{{ 'PLACEHOLDER.CARID' | transloco
              }}
            </mat-error>
          }
          @if (selfServiceForm.get('carRegNumber').errors?.minlength) {
            <mat-error>{{ 'ERROR.CARID' | transloco
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.PERSONS' | transloco }}</mat-label>
          <mat-select [formControl]='selfServiceForm.controls["passengers"]'>
            @for (item of persons; track item) {
              <mat-option [value]="item.value">
                {{item.viewValue}}
              </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
          <mat-select [formControl]='selfServiceForm.controls["parkingFrom"]'
            (selectionChange)="onParkingStartChange($event)" [compareWith]="compareParkingFrom">
            <mat-option [value]="this.arriveAtParking270Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.4.5_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking270Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking255Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.4.25_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking255Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking240Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.4_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking240Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking225Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.3.75_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking225Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking210Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.3.5_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking210Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking195Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.3.25_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking195Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking180Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.3_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking180Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking165Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.2.75_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking165Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking150Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.2.5_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking150Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking135Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.2.25_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking135Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking120Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.2_HOURS_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking120Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking105Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.1.75_HOUR_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking105Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking90Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.1.5_HOUR_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking90Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking75Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.1.25_HOUR_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking75Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
            <mat-option [value]="this.arriveAtParking60Min">
              <div class="display-flex">
                <span class="mr-2">
                  {{ 'PLACEHOLDER.1_HOUR_BEFORE' | transloco }}
                </span>
                <div class="spacer"></div>
                <span class="font-weight-light">Kl:
                  {{this.arriveAtParking60Min | date: 'HH:mm'}}
                </span>
              </div>
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>schedule</mat-icon>
        </mat-form-field>
        <mat-checkbox [formControl]='selfServiceForm.controls["contact"]' class="font-weight-light">{{
        'FLYGETS.SELFSERVICE.CONTACT' | transloco}}</mat-checkbox>
        <p class="consent font-weight-light mb-3">{{ 'FLYGETS.SELFSERVICE.CHANGEPARKINGLENGTH' | transloco}}</p>
        <app-textarea-input [formControl]='selfServiceForm.controls["comment"]' [label]="'FORM.COMMENT' | transloco"
          [placeholder]="'PLACEHOLDER.OPTIONAL_INFO' | transloco">
        </app-textarea-input>
        <mat-checkbox [formControl]='selfServiceForm.controls["consent"]' class="font-weight-light">{{ 'FORM.TERMS' |
        transloco}}</mat-checkbox>
        <p class="consent font-weight-light mb-3 cursor-pointer" (click)="openConsent()">{{ 'FORM.READTERMS' |
        transloco }}</p>
        <button mat-raised-button type="button" class="my-2 width-100" (click)="saveDetails()"
          [disabled]="selfServiceForm.status === 'INVALID' || isLoading"
          [ngClass]="{'success-button': selfServiceForm.status === 'VALID' && !isLoading}">
          @if (isLoading) {
            <mat-icon>
              <mat-spinner color="accent" diameter="20">
              </mat-spinner>
            </mat-icon>
            }{{ 'FORM.CONTINUE' | transloco | uppercase}}
          </button>
          <button mat-raised-button color="warn" type="button" (click)="resetSelfServiceForm()">
            {{ 'FORM.CLEAR' | transloco | uppercase}}
          </button>
        </form>
      </div>
    }

    @if (selfServiceData && selfServiceData.result=='DetailsSaved') {
      <div class="container py-4">
        <section class="img-container text-center img-fluid py-4">
          <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="logo"
            class="logo-width-50-inline">
          <div class="centered py-4">
            <h1>{{ 'FLYGETS.SELFSERVICE.TITLE' | transloco }}</h1>
            <p class="lead">{{ 'FLYGETS.SELFSERVICE.BODY_RESULT2' | transloco }}</p>
          </div>
        </section>
      </div>
    }